import { useEffect, useRef } from 'react';
import { useSweepCanvasState } from '../internal-context/CanvasStateContext';
import { CanvasElementType } from '../canvas-types';
import { useGetNodeAbsolutePosition } from '../helpers/useGetNodeAbsolutePosition';
import { useSweepCanvasFitView } from '../useSweepCanvasFitView';

export const useFitEditingNodeToViewEffect = () => {
  const { canvasNodes: nodes } = useSweepCanvasState();
  const { setCenter } = useSweepCanvasFitView();

  const editingNodeId = nodes.find((node) => node.type === CanvasElementType.EDITABLE)?.id;
  const { getNodeAbsolutePosition } = useGetNodeAbsolutePosition();

  const nodeHasFocused = useRef(false);
  useEffect(() => {
    if (editingNodeId && !nodeHasFocused.current) {
      nodeHasFocused.current = true;

      const absolutePosition = getNodeAbsolutePosition(editingNodeId);
      if (absolutePosition) {
        setCenter(absolutePosition.x, absolutePosition.y, {
          zoom: 0.7,
          duration: 300,
        });
      }
    }
    if (!editingNodeId) {
      nodeHasFocused.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingNodeId]);
};
